import { SignIn, SignUp } from "@clerk/react";
import { img } from "@/lib/api";
import { useShop, useSeo } from "@/lib/store";

function Shell({ children, title }) {
  const { settings } = useShop();
  return (
    <div className="grid lg:grid-cols-2 min-h-[80vh]">
      <div className="hidden lg:flex relative overflow-hidden">
        {settings.hero_image_2 && <img src={img(settings.hero_image_2)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
        <p className="relative mt-auto p-12 font-display text-7xl leading-[0.85]">{title}</p>
      </div>
      <div className="flex items-center justify-center py-12 px-4">{children}</div>
    </div>
  );
}

export function SignInPage() {
  useSeo("Sign in");
  return <Shell title={<>WELCOME BACK<br /><span className="text-neon">TO THE DEN.</span></>}><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></Shell>;
}

export function SignUpPage() {
  useSeo("Create account");
  return <Shell title={<>JOIN<br /><span className="text-neon">THE DEN.</span></>}><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></Shell>;
}
